import { brandLabel, varianceDriverLabel } from './varianceSummaryTableModel.js';

export const downloadCsv = (rows) => {
  const headers = [
    'BAC', 'Dealer', 'Brand', 'Variance Driver',
    'GM Total', 'CPQ Total', 'DPE Total', 'AppSheet Total',
    'GM-CPQ', 'GM-DPE', 'CPQ-DPE', 'Reviewed', 'Category', 'Remediation',
  ];
  const escape = (v) => {
    const raw = String(v ?? '');
    const s = /^[\s\p{Cc}]*[=+\-@]/u.test(raw) ? `'${raw}` : raw;
    return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [headers.join(',')];
  for (const r of rows) {
    lines.push([
      r.bac, r.dealerDisplayName || r.dealerName, brandLabel(r) || r.brand,
      varianceDriverLabel(r),
      r.gmTotal, r.cpqTotal, r.dpeTotal, r.appSheetTotal ?? r.app_sheet_total ?? '',
      r.deltas.gmVsCpq, r.deltas.gmVsDpe, r.deltas.cpqVsDpe,
      r.review?.reviewed ? 'Yes' : 'No',
      r.review?.category || '',
      r.review?.remediation || '',
    ].map(escape).join(','));
  }
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `billing-reconciliation-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
